/**
 * FlexiPage Theme
 * Cryonix.cz
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license Commercial
 */
"use strict";
var nav_1 = require('./nav');
var email_1 = require('./email');
var styles_1 = require('./styles');
var form_1 = require('./form');
var bindScrollState = function () {
    var update = function () {
        var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        if (scrollTop > 0 && !document.body.classList.contains('scrolled'))
            document.body.classList.add('scrolled');
        else if (scrollTop <= 0 && document.body.classList.contains('scrolled'))
            document.body.classList.remove('scrolled');
    };
    window.addEventListener("scroll", update);
};
/**
 * Binds lazy images which appears when loaded
 */
var bindLazyImages = function (parent, selector) {
    if (parent === void 0) { parent = document.body; }
    if (selector === void 0) { selector = "img.lazyload"; }
    var bind = function (el) {
        el.addEventListener("load", function () {
            el.classList.add("loaded");
        });
        if (el.complete)
            el.classList.add("loaded");
    };
    var elements = parent.querySelectorAll(selector);
    for (var i = 0; i < elements.length; i++)
        bind(elements.item(i));
};
window.addEventListener("load", function () {
    nav_1.bindMenuElements();
    bindScrollState();
    email_1.rewriteEmails();
    styles_1.bindMoreBlocks();
    nav_1.bindAnchorNav();
    form_1.bindForms();
    bindLazyImages(undefined, "img.editor-content-image");
});



/*****************
 ** WEBPACK FOOTER
 ** ./ts/index.ts
 ** module id = 0
 ** module chunks = 0
 **/